import React from 'react';

import LogoBg from '@assets/icons/fielder-logo-404.svg';
import LogoFielder from '@assets/icons/logo-login-main.svg';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
	Container,
	Logo,
	LogoBackground,
	Line,
	ErrorCode,
	ErrorText,
	StyledButtonWrapper
} from './Style';

const Forbidden403 = ({ lan, redirect }) => {
	const goBack = () => window.history.back();

	return (
		<Grid container justifyContent="center" alignItems="stretch" spacing={3}>
			<Container container direction="column">
				<Grid>
					<Logo src={LogoFielder} alt="Fielder Logo" />
				</Grid>
				<Grid>
					<ErrorCode variant="h2">
						{lan.pageNoAvailable}
					</ErrorCode>
				</Grid>
				<Grid>
					<Line />
				</Grid>
				<Grid>
					<ErrorText variant="h2">
						{lan.textNotAvailable}
					</ErrorText>
				</Grid>
				{redirect && (
					<StyledButtonWrapper item>
						<Button onClick={goBack} size="small" className="Fielder-button">
							{lan.return}
						</Button>
					</StyledButtonWrapper>
				)}
			</Container>

			<Grid container justifyContent="flex-start" alignItems="flex-end">
				<Grid>
					<LogoBackground src={LogoBg} alt="Background" />
				</Grid>
			</Grid>
		</Grid>
	);
};

export default Forbidden403;
